import { ref, computed } from '@vue/composition-api'
import { constants as c } from '@kingpin-global/kingpin-utils-frontend'
import store from '@/store'
import { GET_ORDER_LIST } from '@/store/modules/order.module'

const { BRAND_ACCESS } = c

const DASHBOARD_ORDERS_LIMIT = 5

export function useDashboardOrders() {
  const orders = ref([])
  const isLoaded = ref(false)

  const profile = computed(() => store.state.auth.profileData)
  const isEnabledMarketplace = computed(
    () => profile.value?.access?.includes(BRAND_ACCESS.MARKETPLACE),
  )

  async function fetchOrders() {
    try {
      const res = await store.dispatch(GET_ORDER_LIST, { limit: DASHBOARD_ORDERS_LIMIT })
      orders.value = res?.data?.data?.orders || []
    } catch (e) {
      // Preserve legacy silent-catch behavior
    } finally {
      isLoaded.value = true
    }
  }

  return {
    orders,
    isLoaded,
    profile,
    isEnabledMarketplace,
    fetchOrders,
  }
}
